<template lang="pug">
#coach_detail
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    #accordion.mb-5
      .coach_card.mb-4.border-radius-10
        .coach_detail.flex_h
          img.coach_head_img(
            :src="coachDetail.photo ? coachDetail.photo.image : imgs.basketballImg"
          )
          .coach_info
            .coach_name {{ coachDetail.name }}
            hr
            .coach_title {{ coachDetail.title }}
        .coach_intro_title.flex_h.mt-5
          img(src="@/assets/img/icons/graduation-cap-solid.svg")
          h5.intro_title 學歷
          .intro_divider_wrapper
            .intro_divider
        .intro_items
          .intro_item(
            v-for="education in coachDetail.educations",
            :key="education.id"
          )
            p {{ education.name }}
              span {{ education.title }}
            span {{ education.start_at }} - {{ education.end_at }}
        .coach_intro_title.flex_h.mt-5
          img(src="@/assets/img/icons/medal-solid.svg")
          h5.intro_title 經歷
          .intro_divider_wrapper
            .intro_divider
        .intro_items
          .intro_item(
            v-for="work in coachDetail.work_experiences",
            :key="work.id"
          )
            p {{ work.name }}
              span {{ work.title }}
            span {{ work.start_at }} - {{ work.end_at }}
        .coach_intro_title.flex_h.mt-5
          img(src="@/assets/img/icons/trophy-solid.svg")
          h5.intro_title 里程碑
          .intro_divider_wrapper
            .intro_divider
        .intro_items.events
          .intro_item.flex_h(
            v-for="event in coachDetail.life_events",
            :key="event.id"
          )
            .date_wrapper
              span {{ event.occur_at }}
              .hollow_circle
            .event_info
              a.referaece_link(
                v-if="event.link",
                :href="event.link",
                target="_blank"
              ) {{ event.name }}
                span.ml-1(v-if="event.link")
                  img(src="@/assets/img/icons/link-solid.svg")
              a.referaece_link(v-else) {{ event.name }}
              span.event_des {{ event.description }}
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getCoachDetail } from "@/api/web_content";
import basketballImg from "@/assets/img/icons/basketball-ball-solid.svg";

export default {
  name: "News",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "教練介紹",
      coachDetail: {
        photo: {
          src: "",
        },
      },
      imgs: {
        basketballImg,
      },
    };
  },
  created() {
    this.getCoachDetail(this.$route.query.id);
  },
  methods: {
    getCoachDetail(id) {
      getCoachDetail(id).then((response) => {
        this.coachDetail = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#accordion {
  max-width: 992px;
  margin: 0 auto;
}

.coach_card {
  border-radius: 10px;
  padding-left: 51px;
  padding-right: 51px;
  padding-top: 35px;
  padding-bottom: 45px;
  background: $color_bg_white;
  border: $color_gray 1px solid;
}

.coach_detail {
  align-items: center;
}

.coach_head_img {
  width: 160px;
  height: 160px;
  background-color: #ccc;
  border-radius: 50%;
}

.coach_info {
  margin-left: 60px;
  flex-grow: 1;

  .coach_name {
    font-size: 28px;
    font-weight: bold;
    color: $c-text;
  }

  .coach_title {
    color: $c-text;
  }
}

.coach_intro_title {
  justify-content: space-between;
  align-items: center;
}

.intro_title {
  margin-left: 10px;
  font-size: 20px;
  color: $c-text;
  font-weight: 500;
}

.intro_divider_wrapper {
  position: relative;
  width: calc(100% - 120px);
  margin-left: 22px;

  .intro_divider {
    border-top: $color_gray 1px solid;
    width: 100%;

    &::after {
      border-top: $color_dark_blue 6px solid;
      content: "";
      display: block;
      width: 60px;
      position: absolute;
      right: 0;
    }
  }
}

.intro_items {
  margin-top: 42px;
  padding-left: 15px;
}

.intro_item {
  border-left: 1px solid $color_blue;
  padding-bottom: 46px;
  padding-left: 25px;

  p,
  a {
    font-size: 20px;
    font-weight: 500;
    color: #363636;

    span {
      margin-left: 20px;
    }
  }

  span {
    font-size: 16px;
    font-weight: 400;
    color: #6d7278;
  }
}

.intro_item:last-child {
  padding-bottom: 0;
}

.date_wrapper {
  position: relative;
  height: fit-content;

  span {
    line-height: 18px;
  }

  p {
    span {
      margin-left: 5px;
    }
  }
}

.hollow_circle {
  width: 14px;
  height: 14px;
  border: 2px solid $color_blue;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(calc(-50% - 25px), 0);
}

.event_info {
  padding-left: 20px;
}

.event_des {
  display: block;
  margin-top: 1rem;
}

.intro_items.events {
  .intro_item:last-child {
    border-left: 1px solid transparent;
    padding-bottom: 46px;
    padding-left: 25px;

    &::before {
      content: "";
      display: block;
      border-left: 1px solid #d0d0d0;
      height: 10px;
      transform: translateX(-26px);
    }
  }
}

@media (max-width: 767px) {
  .coach_card {
    border-radius: 10px;
    box-shadow: 2px 2px 16px #00000023;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 35px;
    padding-bottom: 45px;
  }

  .post-date {
    clear: right;
    float: none;
  }

  .read_more {
    margin-top: 20px;
  }
}
</style>
